import React from 'react'
import {
  FieldGrid,
  FieldGroup,
  LabeledToggleRow,
  NumberField,
  SettingsPane,
  ToggleList,
} from '../organization-ui'
import type { OrganizationSettingsFormProps } from '../settings/organizationSettingsForm.types'

export const ShiftAlertsPane: React.FC<OrganizationSettingsFormProps> = ({
  register,
  setValue,
  watch,
  errors,
  disabled = false,
}) => (
  <SettingsPane
    title="Shift alerts"
    description="How staff are reminded before a shift, and what happens when they don't respond."
  >
    <FieldGroup label="Reminders">
      <FieldGrid>
        <NumberField
          label="Pre-shift alert"
          min={0}
          unit="min"
          disabled={disabled}
          hint="Sent this long before the shift starts."
          error={errors.shiftAlertSettings?.preShiftAlertMinutes?.message}
          {...register('shiftAlertSettings.preShiftAlertMinutes', { valueAsNumber: true })}
        />
        <NumberField
          label="Reminder interval"
          min={0}
          unit="min"
          disabled={disabled}
          hint="Gap between repeat reminders."
          error={errors.shiftAlertSettings?.reminderIntervalMinutes?.message}
          {...register('shiftAlertSettings.reminderIntervalMinutes', { valueAsNumber: true })}
        />
        <NumberField
          label="Max missed reminders"
          min={0}
          disabled={disabled}
          hint="Escalation triggers after this many."
          error={errors.shiftAlertSettings?.maxMissedReminders?.message}
          {...register('shiftAlertSettings.maxMissedReminders', { valueAsNumber: true })}
        />
      </FieldGrid>
    </FieldGroup>

    <FieldGroup label="Escalation">
      <ToggleList>
        <LabeledToggleRow
          label="Escalate to admin"
          description="Notify admins once the missed reminder limit is reached."
          checked={watch('shiftAlertSettings.escalateToAdmin') ?? false}
          disabled={disabled}
          onChange={(checked) =>
            setValue('shiftAlertSettings.escalateToAdmin', checked, { shouldDirty: true })
          }
        />
        <LabeledToggleRow
          label="Suppress alerts on approved leave"
          description="Skip shift reminders for staff with approved time off."
          checked={watch('shiftAlertSettings.suppressForLeave') ?? false}
          disabled={disabled}
          onChange={(checked) =>
            setValue('shiftAlertSettings.suppressForLeave', checked, { shouldDirty: true })
          }
        />
      </ToggleList>
    </FieldGroup>
  </SettingsPane>
)

ShiftAlertsPane.displayName = 'ShiftAlertsPane'
